import { Divider, HStack, Input, InputGroup, VStack } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { ResolvedLoanFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { percentageToPercentageLabel } from '~/packages/common-frontend/utils';

export const PricingOptionDetails = ({
  loan,
  isDisabled,
}: {
  loan: ResolvedLoanFragmentGQLType;
  isDisabled?: boolean;
}) => (
  <VStack
    alignItems="flex-start"
    w="100%"
    sx={{
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: 'md',
      p: '1.5rem',
      gap: '0.75rem',
    }}
  >
    <HStack justifyContent="space-between" w="100%">
      <Typography fontWeight="bold">All-in-Rate</Typography>
      <Typography fontWeight="bold">
        {percentageToPercentageLabel(
          loan.pricing.current.allInRate * 100,
          5,
          true,
        )}
      </Typography>
    </HStack>
    <Divider />
    <HStack justifyContent="space-between" w="100%">
      <Typography variant="base-muted">Benchmark</Typography>
      <Typography variant="base-muted">
        {commonUtils.toTitleCase(loan.pricing.current.baseRate.name)}
      </Typography>
    </HStack>
    <HStack justifyContent="space-between" w="100%">
      <Typography variant="base-muted">Benchmark Determination Date</Typography>
      <InputGroup bgColor="white" maxW="20rem">
        <Input
          isDisabled={isDisabled}
          type="date"
          value={loan.pricing.current.baseRate.determinationDate}
        />
      </InputGroup>
    </HStack>
    <HStack justifyContent="space-between" w="100%">
      <Typography variant="base-muted">Benchmark Rate</Typography>
      <Typography variant="base-muted">
        {percentageToPercentageLabel(
          loan.pricing.current.baseRate.publishedRate * 100,
          5,
          true,
        )}
      </Typography>
    </HStack>
    <HStack justifyContent="space-between" w="100%">
      <Typography variant="base-muted">WA Applicable Margin</Typography>
      <Typography variant="base-muted">
        {percentageToPercentageLabel(
          loan.pricing.current.weightedAverageMarginRate * 100,
          5,
          true,
        )}
      </Typography>
    </HStack>
    <HStack justifyContent="space-between" w="100%">
      <Typography variant="base-muted">Interest Calculation</Typography>
      <Typography variant="base-muted">-</Typography>
    </HStack>
  </VStack>
);
